export default __webpack_public_path__ + "images/9ddfc0f1c6c4770f41cc9c417c87ccae.png";